import { ClientType } from 'shared/types/config-server'

export function displayType(routeName?: string | null | undefined): ClientType {

if(!routeName) { return 'global' }
switch(routeName) {
		case 'race':
		case 'scroll':
		case 'spectator':
		case 'participant':
			return 'race'
		case 'leaderboard':
		case 'summary':
			return 'leaderboard'
		case 'cameras1':
		case 'cameras2':
		case 'cameras3':
		case 'split':
			return 'cameras'
		default:
			return 'global'
	}
}
